package com.bikompanion.data.rating.firebase

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseApp
import dev.gitlive.firebase.initialize

internal actual fun initializeFirebase(): FirebaseApp = Firebase.initialize(options = buildFirebaseOptions())
